import React from 'react'
import { Card } from 'react-bootstrap'

export default function OrderDetailLoading() {
  return (
    <>
      {/* <div style={{position:"absolute", display:"flex", top:"0px", left:"0px", right:"0px", bottom:"0px"}}> */}
      <div
        className="card-body"
        style={{
          display: 'flex',
          width: '100%',
          maxHeight: '1000px',
          overflow: 'hidden',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card className="p-4" style={{ overflow: 'hidden', width: '100%' }}>
          <div style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </Card>
      </div>
    </>
  )
}
